import styled from "styled-components";

export const StyledLoginButton = styled.button`
  background: linear-gradient(184.47deg, #faa713 -64.78%, #f1591e 148.72%);
  border: none;
  padding: 10px 29px;
  text-transform: uppercase;
  font-size: 16px;
  line-height: 20px;
  font-weight: 500;
  margin-top: 1rem;
  width: 100%; 
  color: #fff;
  border-radius: .25rem;
  cursor: pointer;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif ;
transition: all 250ms cubic-bezier(0.27, 0.01, 0.38, 1.06);

  &:hover {
  color: var(--white);
  background-color: #faa713;
  border-color: #f1591e;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05), 0 4px 10px rgba(0, 123, 255, 0.25);
  }
  }
`;
